<template>
    <div>
        <div id="register" class="wrapper m0-50 critical">
            <div class="section">
                <div class="div-block-15">
                    <div class="form-container">
                        <div class="form-block w-form">
                            <div id="email-form" class="form-wrapper">
                                <div class="form-title-container">
                                    <div class="form-title">Register for Access</div>
                                    <p>Already have an account? <router-link class="link-blue" v-bind:to="'/Login'">Login Now.</router-link></p>
                                </div>
                                <form @submit.prevent="submit">
                                    <div class="input-container" :class="{ 'hasError': $v.form.companyName.$error }">
                                        <label for="company" class="input-label">Company</label>
                                        <input type="text"
                                               v-model="form.companyName"
                                               @blur="$v.form.companyName.$touch()"
                                               class="text-input w-input"
                                               autofocus="true" maxlength="256"
                                               name="company"
                                               placeholder="Company Name"
                                               id="company">
                                        <div class="text-red" v-if="$v.form.companyName.$error">
                                            <div v-if="!$v.form.companyName.required">Company name is required</div>
                                        </div>
                                    </div>
                                    <div class="input-container">
                                        <div class="w-row">
                                            <div class="upper-input-container w-col w-col-6" :class="{ 'hasError': $v.form.firstName.$error }">
                                                <label for="first-name" class="input-label">First Name</label>
                                                <input type="text" v-model="form.firstName"
                                                       @blur="$v.form.firstName.$touch()"
                                                       class="text-input w-input"
                                                       maxlength="256"
                                                       name="first-name"
                                                       placeholder="First Name"
                                                       id="first-name">
                                            </div>
                                            <div class="lower-input-container w-col w-col-6" :class="{ 'hasError': $v.form.lastName.$error }">
                                                <label for="last-name" class="input-label">Last Name</label>
                                                <input type="text"
                                                       v-model="form.lastName"
                                                       @blur="$v.form.lastName.$touch()"
                                                       class="text-input w-input"
                                                       maxlength="256"
                                                       name="last-name"
                                                       data-name="last-name"
                                                       placeholder="Last Name"
                                                       id="last-name">
                                            </div>
                                        </div>
                                        <div class="text-red" v-if=" $v.form.firstName.$error ||  $v.form.lastName.$error">
                                            <div v-if="!$v.form.firstName.required">First name is required</div>
                                            <div v-if="!$v.form.lastName.required">Last name is required</div>
                                        </div>
                                    </div>
                                    <div class="input-container" :class="{ 'hasError': $v.form.email.$error }">
                                        <label for="email" class="input-label">Email</label>
                                        <input type="email"
                                               v-model="form.email"
                                               @blur="$v.form.email.$touch()"
                                               class="text-input w-input"
                                               maxlength="256" name="email"
                                               placeholder="Enter your email..."
                                               id="email">
                                        <div class="text-red" v-if="$v.form.email.$error">
                                            <div v-if="!$v.form.email.required">Email is required</div>
                                            <div v-if="!$v.form.email.email">Email is not a properly formatted email address</div>
                                        </div>
                                    </div>
                                    <div class="input-container">
                                        <label for="phone" class="input-label">Contact Phone Number (Optional)</label>
                                        <input type="tel"
                                               v-model="form.phoneNumber"
                                               class="text-input w-input"
                                               maxlength="256"
                                               name="phone"
                                               placeholder="(XXX) XXX-XXXX"
                                               id="phone">
                                    </div>
                                    <div class="input-container">
                                        <div class="w-row">
                                            <div class="upper-input-container w-col w-col-6" :class="{ 'hasError': $v.form.password.$error }">
                                                <label for="password-2" class="input-label">Password</label>
                                                <input type="password"
                                                       v-model="form.password"
                                                       @blur="$v.form.password.$touch()"
                                                       class="text-input w-input"
                                                       maxlength="256"
                                                       name="password"
                                                       data-name="password"
                                                       placeholder="Password"
                                                       id="password-2"></div>
                                            <div class="lower-input-container w-col w-col-6" :class="{ 'hasError': $v.form.confirmPassword.$error }">
                                                <label for="confirm-password" class="input-label">Confirm Password</label>
                                                <input type="password"
                                                       v-model="form.confirmPassword"
                                                       @blur="$v.form.confirmPassword.$touch()"
                                                       class="text-input w-input"
                                                       maxlength="256"
                                                       name="confirm-password"
                                                       data-name="confirm-password"
                                                       placeholder="Confirm Password"
                                                       id="confirm-password">
                                            </div>
                                        </div>
                                        <div class="text-red" v-if=" $v.form.password.$error ||  $v.form.confirmPassword.$error">
                                            <div v-if="!$v.form.password.required">Password is required</div>
                                            <div v-if="!$v.form.password.minLength">Password should be at-least 8 character</div>
                                            <div v-if="!$v.form.password.strongPassword">Password should have 1 special character, 1 lowercase, 1 uppercase, and  1 number</div>
                                            <div v-if="!$v.form.confirmPassword.required">Confirm password is required</div>
                                            <div v-if="!$v.form.confirmPassword.sameAsPassword">Password should match.</div>
                                        </div>
                                    </div>
                                    <div class="input-container">
                                        <label class="input-label">Company Type (Select all that apply)</label>
                                        <div class="question-description">End-products are the 12 product categories outlined in the Government of Canada&#x27;s request for products and services: <a href="https://buyandsell.gc.ca/calling-all-suppliers-help-canada-combat-covid-19" class="link-3">https://buyandsell.gc.ca/calling-all-suppliers-help-canada-combat-covid-19</a>
                                        </div>
                                        <label class="w-checkbox checkbox-field-container">
                                            <input class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" v-model="form.accountTypeCheck" value="END_PRODUCT_PRODUCER" type="checkbox" id="END_PRODUCT_PRODUCER">
                                            <span class="checkbox-label w-form-label">End-product producer</span>
                                        </label>
                                        <label class="w-checkbox checkbox-field-container">
                                            <input class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" v-model="form.accountTypeCheck" value="INPUT_MATERIAL_PRODUCER" type="checkbox" id="INPUT_MATERIAL_PRODUCER">
                                            <span class="checkbox-label w-form-label">Input material producer</span></label>
                                        <label class="w-checkbox checkbox-field-container">
                                            <input class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-select" v-model="form.accountTypeCheck" value="END_PRODUCT_USER" type="checkbox" id="END_PRODUCT_USER">
                                            <span class="checkbox-label w-form-label">End-product user</span>
                                        </label>
                                    </div>
                                    <div class="input-container">
                                        <div>
                                            <label class="input-label">Company Logo (Optional)</label>
                                            <div v-if="!fileUploadSuccess" >
                                            <div v-on:click="toggleFileUpload()" data-w-id="35485cd1-894c-4ba8-0bff-0c08cf8efc46" class="add-file-button">
                                                <img src="../assets/images/add_24px.png" alt="" class="add-file-icon">
                                                <div>Add File</div>
                                            </div>
                                            <modal v-if="isFileUploadModalOpen" class="add-file-modal-wrapper" style="opacity: 1; display: flex;">
                                                <div class="modal-background">
                                                    <div class="modal-title-container">
                                                        <div class="modal-header">Add Files</div>
                                                    </div>
                                                        <div class="add-file-drop-area">
                                                            <div class="file-drop-area-height">
                                                                <ul v-if="files.length">
                                                                    <li v-for="(file) in files" :key="file.id">
                                                                        <img v-if="file.thumb" :src="file.thumb" height="100" width="auto" />
                                                                        <span v-else>No Image</span>
                                                                        <span v-if="file.error">{{file.error}}</span>
                                                                        <span v-else></span>
                                                                        <span><button class="choose-files-button w-button remove-file-button" @click.prevent="$refs.upload.remove(file)">Remove</button></span>
                                                                    </li>
                                                                </ul>
                                                                <ul v-else>
                                                                    <div class="center-align">
                                                                        <div class="drag-files-here">Drag files here</div>
                                                                        <div>- or -</div>
                                                                        <label for="file" class="choose-files-button w-button">Select files from your computer</label>
                                                                    </div>
                                                                </ul>
                                                            </div>
                                                            <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                                                                <h3>Drop files to upload</h3>
                                                            </div>
                                                        </div>
                                                    <div>
                                                        <FileUpload
                                                                :custom-action="uploadToS3"
                                                                extensions="gif,jpg,jpeg,png"
                                                                accept="image/png,image/gif,image/jpeg"
                                                                :multiple="false"
                                                                :size="1024 * 1024 * 10"
                                                                :drop="true"
                                                                v-model="files"
                                                                ref="upload"
                                                                @input-filter="inputFilter"
                                                                >
                                                        </FileUpload>
                                                        <button type="button" class="upload-files-button w-button"  :disabled="!files.length" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
                                                            Upload
                                                        </button>

                                                    </div>
                                                    <div  v-on:click="toggleFileUpload()" class="close-modal-button"><img src="../assets/images/close.png" alt=""></div>

                                                </div>
                                            </modal>
                                            </div>
                                            <div v-else>
                                                <img v-if="logoUrl" :src="logoUrl" width="auto" height="75" />
                                            </div>
                                        </div>
                                    </div>
                                    <div>By clicking 'Register' below, you agree to the Rapid Response Platform's <router-link class="link-blue" v-bind:to="'/end-user-agreement'" target="_blank">End User Agreement.</router-link></div>
                                    <button type="submit" data-wait="Please wait..." class="submit-button w-button float-right">Register</button>
                                </form>
                            </div>
                            <div class="input-container form-success" v-if="success">
                                <div>Thank you! Please check your email for account confirmation link.</div>
                            </div>
                            <div class="input-container form-fail" v-if="fail">
                                <div>Oops! Something went wrong. If you already have account please <router-link class="link-blue" v-bind:to="'/login'">login.</router-link></div>
                            </div>
                            <div class="input-container form-fail" v-if="validation">
                                <div>{{validationMessage}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { registrationService } from '../assets/js/services/registrationService';
    import {email, minLength, sameAs, required} from "vuelidate/lib/validators";
    import Compressor from 'compressorjs';
    import FileUpload from 'vue-upload-component'
    import {fileUploadService} from "../assets/js/services/fileUploadService";

    export default {
        name: "Register",
        components: {
            FileUpload
        },
        data() {
            return {
                form: {
                    accountTypeCheck: [],
                    companyName: "",
                    email: "",
                    firstName: "",
                    lastName: "",
                    password: "",
                    confirmPassword: "",
                    phoneNumber: "",
                    account: {
                        businessName: "",
                        accountType: "" //Comma delimited list
                    },
                },
                isFileUploadModalOpen: false,
                files: [],
                logoUrl: "",
                fileUploadSuccess : false,
                success: false,
                fail: false,
                validation: false,
                validationMessage: ""
            }
        },

        validations: {
            form: {
                firstName: { required },
                lastName: { required },
                password: { required, minLength: minLength(8),
                    strongPassword(password) {
                        const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
                        return passwordRegex.test(password);
                    }},
                confirmPassword: { required, sameAsPassword: sameAs('password')},
                email: { required, email },
                companyName: {required}
            }
        },


        created () {
            document.title = "Register";
        },
        methods: {
            submit () {
                this.validation = false;
                this.validationMessage = "";
                this.success = false;
                this.fail = false;

                this.$v.form.$touch();
                if(this.$v.form.$error) return;

                let account = {
                    businessName: this.form.companyName,
                    accountType: this.form.accountTypeCheck.toString(),
                    logoUrl: this.logoUrl ? this.logoUrl : null
                };

                registrationService.register(this.form.email,
                    this.form.firstName,
                    this.form.lastName,
                    this.form.password,
                    this.form.confirmPassword,
                    this.form.phoneNumber,
                    account)
                    .then(() => {this.success = true;})
                    .catch((error) => {
                        if (error.status === 'UNPROCESSABLE_ENTITY'){
                            this.validation = true;
                            this.validationMessage = error.content;
                        }
                        else {
                            this.fail = true;
                        }
                    });
            },
            toggleFileUpload: function () {
                if (this.isFileUploadModalOpen)
                    this.isFileUploadModalOpen = false;
                else
                    this.isFileUploadModalOpen = true;
            },
            uploadToS3: function (file) {
                return fileUploadService.uploadLogo(file.file)
                    .then((logoUrl) => {
                        this.isFileUploadModalOpen = false;
                        this.logoUrl = logoUrl;
                        this.fileUploadSuccess = true;
                    })
                    .catch(() => {
                        this.isFileUploadModalOpen = false;
                        this.logoUrl = '';
                        this.fileUploadSuccess = false;
                    });
            },
            inputFilter: function(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    if (newFile.file && newFile.type.substr(0, 6) === 'image/' && this.autoCompress > 0 && this.autoCompress < newFile.size) {
                        newFile.error = 'compressing';
                        const imageCompressor = new Compressor(null, {
                            convertSize: Infinity,
                            maxWidth: 512,
                            maxHeight: 512,
                        })
                        imageCompressor.compress(newFile.file)
                            .then((file) => {
                                this.$refs.upload.update(newFile, { error: '', file, size: file.size, type: file.type })
                            })
                            .catch((err) => {
                                this.$refs.upload.update(newFile, { error: err.message || 'compress' })
                            })
                    }
                }
                if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                    newFile.blob = '';
                    let URL = window.URL || window.webkitURL;
                    if (URL && URL.createObjectURL) {
                        newFile.blob = URL.createObjectURL(newFile.file)
                    }
                    newFile.thumb = '';
                    if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                        newFile.thumb = newFile.blob
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .center-align{
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .file-drop-area-height{
        height: 100% !important;
    }

    .remove-file-button {
        margin-left: 20px;
        background-color: #db4b68;
        color: #ffffff;
    }
</style>
